import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Sidebar } from "@/shared/components/layout/sidebar";
import { Topbar } from "@/shared/components/layout/topbar";
import { getAcademyProfile } from "@/modules/settings/api/settings";
import { setDateFormat } from "@/shared/utils/date";

export function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const profileQuery = useQuery({
    queryKey: ["academy-profile"],
    queryFn: getAcademyProfile,
    staleTime: 5 * 60 * 1000,
  });

  useEffect(() => {
    if (profileQuery.data?.dateFormat) {
      setDateFormat(profileQuery.data.dateFormat);
    }
  }, [profileQuery.data?.dateFormat]);

  return (
    <div className="flex min-h-screen">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex flex-1 flex-col min-w-0">
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main className="flex-1 p-4 lg:p-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
